var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form-item",
        { attrs: { label: "量级设置" } },
        [
          _c("el-input-number", {
            attrs: { min: 1, max: 100, label: "描述文字" },
            model: {
              value: _vm.activeData.table.level,
              callback: function ($$v) {
                _vm.$set(_vm.activeData.table, "level", $$v)
              },
              expression: "activeData.table.level",
            },
          }),
        ],
        1
      ),
      _vm.activeData.table.copyWriting
        ? _c(
            "el-form-item",
            { attrs: { label: "最低分文案" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入最低分文案" },
                model: {
                  value: _vm.activeData.table.copyWriting.min,
                  callback: function ($$v) {
                    _vm.$set(_vm.activeData.table.copyWriting, "min", $$v)
                  },
                  expression: "activeData.table.copyWriting.min",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.activeData.table.copyWriting
        ? _c(
            "el-form-item",
            { attrs: { label: "最高分文案" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入最高分文案" },
                model: {
                  value: _vm.activeData.table.copyWriting.max,
                  callback: function ($$v) {
                    _vm.$set(_vm.activeData.table.copyWriting, "max", $$v)
                  },
                  expression: "activeData.table.copyWriting.max",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-form-item",
        { attrs: { label: "图标" } },
        _vm._l(_vm.iconList, function (icon) {
          return _c("span", {
            key: icon,
            class: [icon, icon === _vm.activeData.icon ? "selected" : ""],
            style: _vm.styleObject,
            on: {
              click: function ($event) {
                return _vm.handleSelectIcon(icon)
              },
            },
          })
        }),
        0
      ),
      _c(
        "el-form-item",
        { attrs: { label: "图标颜色" } },
        [
          _c("el-color-picker", {
            model: {
              value: _vm.activeData.iconColor,
              callback: function ($$v) {
                _vm.$set(_vm.activeData, "iconColor", $$v)
              },
              expression: "activeData.iconColor",
            },
          }),
        ],
        1
      ),
      _c("matrix-option", { attrs: { "active-data": _vm.activeData } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }